var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSamsclubProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.samsclub{fill:url(#samsclub-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "samsclub-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d7df23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32277,
    stopColor: "#86af2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48367,
    stopColor: "#5d9732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006551"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "samsclub",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M58.03933,33.57586l-18.48678,10.67346,6.79386,3.92232c.36644.21156.8179.21156,1.18434,0l16.11838-9.30558c.7896-.45586.78961-1.59554.00002-2.0514l-5.60981-3.23881Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M35.3603,41.82896l18.4871-10.67333-6.3164-3.64674c-.36645-.21157-.81792-.21156-1.18437,0l-16.11822,9.30586c-.78959.45587-.78958,1.59554.00001,2.0514l5.13187,2.96282Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M44.26701,51.81206l-6.87174-3.96749v9.87964l-4.19211-2.17681v-10.1232l-5.12063-2.95643c-.76735-.44303-1.72654.11075-1.72654.99681v18.68835c0,.41122.21938.7912.57551.99681l16.18448,9.34412c.76735.44303,1.72653-.11076,1.72653-.99681v-18.68818c0-.41122-.21938-.7912-.5755-.99681Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white",
    points: "52.69573 61.08382 60.8785 52.90105 58.45027 50.47282 48.11298 60.81011 58.45027 71.14738 60.60479 68.99288 52.69573 61.08382"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "white",
    points: "69.06127 61.08382 60.8785 52.90105 63.30673 50.47282 73.64401 60.81011 63.30673 71.14738 61.15221 68.99288 69.06127 61.08382"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamsclubProductsScraper);
export default __webpack_public_path__ + "static/media/samsclub-products-scraper.9f48b6af9341773945a7451990227604.svg";
export { ForwardRef as ReactComponent };